import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const EMAIL = 'gautheron.og@gmail.com';

const Contact = () => {
  const { t, language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section id="contact" className="section section--invert">
      <div className="wrap split">
        <h2 className="split__label">{t('contactTitle')}</h2>
        <div>
          <p className="contact-lede">{t('contactSubtitle')}</p>
          <a href={`mailto:${EMAIL}`} className="contact-mail">
            {EMAIL}
          </a>

          <ul className="contact-list">
            <li>
              <span className="k">LinkedIn</span>
              <a
                href="https://www.linkedin.com/in/olivier-gautheron-og/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {isEn ? "Let's connect" : 'Connectons-nous professionnellement'}
              </a>
            </li>
            <li>
              <span className="k">WhatsApp</span>
              <a href="https://wa.me/+33623306587" target="_blank" rel="noopener noreferrer">
                {isEn ? "Let's discuss" : 'Discutons directement'}
              </a>
            </li>
            <li>
              <span className="k">{t('email')}</span>
              <a href={`mailto:${EMAIL}`}>{isEn ? 'Send me an E-mail' : 'Envoyez-moi un E-mail'}</a>
            </li>
            <li>
              <span className="k">{t('phone')}</span>
              <span>+66 827-143-717 · +33 6 23 30 65 87 (WhatsApp)</span>
            </li>
            <li>
              <span className="k">{t('location')}</span>
              <span>{t('address')}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Contact;
